export type Local = "ganache"

export type EthereumNetwork =
	| "ethereum"
	| "kovan"
	| "rinkeby"
	| "goerli"
	| "ropsten"

export type PolygonNetwork = "polygon" | "mumbai"

export type BlockchainNetwork = Local | EthereumNetwork | PolygonNetwork

export enum ChainIds {
	"ethereum" = 1,
	"ropsten" = 3,
	"rinkeby" = 4,
	"goerli" = 5,
	"kovan" = 42,
	"polygon" = 137,
	"mumbai" = 80001,

	"ganache" = 1337,
}
